import { Box, Alert } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createAdminSchema } from "../../schema/adminSchema";
import { getLocalStorageValue } from "../../utils/localStorage";
import { mockAdminRegisterFields } from "../../data/mockAdminData";
import { createAdmin } from "../../api/admins";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  phoneNumber: "",
  age: "",
  profilePicture: null,
};

const AdminRegister = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("admin");
    if (result) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(async (values, { resetForm }) => {
    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("password", values.password);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("age", values.age);
    formData.append("profilePicture", values.profilePicture);

    try {
      await createAdmin(formData);
      resetForm();
      navigate("/adminLogin");
    } catch (error) {
      setAlertMessage(error.response.data.msg);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }, [navigate]);

  return (
    <AuthLayout title="Register Admin">
      {/* Alert */}
      {showAlert && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {alertMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={createAdminSchema}
        fields={mockAdminRegisterFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you already have an account"
          link="adminLogin"
          linkText="login"
          buttonText="Create New Admin"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default AdminRegister;
